import React, { useState, useEffect } from "react";
import * as Styled from "./styled";
import Sidemenu from "../../components/sidemenu";
import Header from "../../components/header";
import { functionService } from "../../lib/functions";
import { Select, DatePicker, Dropdown, Menu, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "antd";

import { Link } from "react-router-dom";
import moment from "moment";

const CompanyTable = () => {
  const [jobListings, setJobListings] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  useState(null);

  const [selectedDate, setSelectedDate] = useState(null);
  const [filteredJobListings, setFilteredJobListings] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const navigate = useNavigate();


  const handleOptionClick = (role) => {
    navigate("/company-listing", { state: { role } });
  };

  const [selectedAction, setSelectedAction] = useState(null);
  const [userId, setUserId] = useState(null);

  const getCompanyFirstPage = async () => {
    const email = localStorage.getItem("userEmail");
    const obj = {
      email: email,
    };

    try {
      const firstPageDetails = await functionService.getCompanyFirstPage(obj);
      if (firstPageDetails.status) {
        const jsonData = firstPageDetails.response.data.data;
        setJobListings(jsonData);
      } else {
        console.error("Error fetching details:", firstPageDetails.error);
      }
    } catch (error) {
      console.error("Error in fetch Details:", error);
    }
  };

  useEffect(() => {
    getCompanyFirstPage();
  }, []);

  useEffect(() => {
    let filteredListings = jobListings;
    setFilteredJobListings(filteredListings);
  }, [jobListings]);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedListings = filteredJobListings.slice(
    startIndex,
    startIndex + itemsPerPage
  );
  const totalPages = Math.ceil(filteredJobListings.length / itemsPerPage);

  const menu = (id) => (
    <Menu onClick={(e) => handleMenuClick(e, id)}>
      <Menu.Item key="download">Download Assessment Report</Menu.Item>
      <Menu.Item key="approved">Approve</Menu.Item>
      <Menu.Item key="rejected">Reject</Menu.Item>
    </Menu>
  );

  const handleMenuClick = (e, id) => {
    setSelectedAction(e.key);
    setUserId(id);
  };
  return (
    <Styled.MainDiv>
      <Sidemenu />
      <Header />
      <Styled.ContentWrapDiv>
      <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
          <Select
            showSearch
            placeholder="Select a Job Role" // Updated placeholder for clarity
            optionFilterProp="children" // This allows filtering based on the children of the options
            onChange={(value) => setSelectedCompany(value)}
            allowClear
            style={{ width: "200px" }}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 // Enable filtering based on input
            }
          >
            {companyList.map((item) => (
              <Select.Option key={item.role} value={item.role}> {/* Ensure value is set to item.role for job role */}
                {item.role} {/* Display job role instead of company name */}
              </Select.Option>
            ))}
          </Select>
        </div>
        <Styled.TableWrap>
          <Styled.MainTable>
            <thead>
              <tr>
                <th>Job Role</th>
                <th>No. of candidates</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedListings.map((item, index) => (
                <tr key={index}>
                  <td>{item.role}</td>
                  <td>{item.total_count}</td>
                  <td>
                  <Styled.IconDiv>
                    <Tooltip title="Options">
                      <Styled.OptionButton onClick={() => handleOptionClick(item.role)} />
                    </Tooltip>
                  </Styled.IconDiv>
                  </td>
                </tr>
              ))}
            </tbody>
          </Styled.MainTable>
        </Styled.TableWrap>

        <Styled.ParentContainer>
          <Styled.PaginationDiv>
            <button
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
              style={{ minWidth: "75px" }}
            >
              Previous
            </button>

            {currentPage > 3 && (
              <>
                <button onClick={() => setCurrentPage(1)}>1</button>
                <div className="ellipsis">...</div>
              </>
            )}

            {[...Array(totalPages)].map((_, i) => {
              const pageNumber = i + 1;

              if (
                pageNumber === currentPage ||
                (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
              ) {
                console.log("active page ========>", pageNumber, currentPage);
                return (
                  <Styled.PaginationButton
                    key={i}
                    onClick={() => setCurrentPage(pageNumber)}
                    active={pageNumber == currentPage}
                  >
                    {pageNumber}
                  </Styled.PaginationButton>
                );
              }
              return null;
            })}

            {currentPage < totalPages - 2 && (
              <>
                <div className="ellipsis">...</div>
                <button onClick={() => setCurrentPage(totalPages)}>
                  {totalPages}
                </button>
              </>
            )}

            <button
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages}
              style={{ minWidth: "75px" }}
            >
              Next
            </button>
          </Styled.PaginationDiv>
        </Styled.ParentContainer>
      </Styled.ContentWrapDiv>
    </Styled.MainDiv>
  );
};

export default CompanyTable;

